var map = {
	"./app/activity.png": "SoK4",
	"./app/appointment.png": "89du",
	"./app/article.png": "0dq+",
	"./app/company.png": "ViOo",
	"./app/house.png": "Zg/r",
	"./app/instructions/icon_01.png": "KACT",
	"./app/instructions/icon_02.png": "IoHP",
	"./app/instructions/icon_03.png": "Hipe",
	"./app/instructions/icon_04.png": "olBG",
	"./app/instructions/icon_05.png": "5wiI",
	"./app/instructions/img01@2x.png": "P282",
	"./app/instructions/img02@2x.png": "nUTJ",
	"./app/instructions/img03@2x.png": "sszm",
	"./app/instructions/img04@2x.png": "OQnm",
	"./app/instructions/img05@2x.png": "zmwp",
	"./app/instructions/img06@2x.png": "os4f",
	"./app/instructions/shop_img03@2x.png": "NnxQ",
	"./app/instructions/shop_img04@2x.png": "/ASR",
	"./app/integralshop/shop_img01.png": "fFYP",
	"./app/integralshop/shop_img03.png": "WULN",
	"./app/integralshop/shop_img04.png": "gE67",
	"./app/livebringgoods/icon_step01.png": "/is4",
	"./app/livebringgoods/icon_step02.png": "3HzQ",
	"./app/livebringgoods/img_tips.png": "n8sm",
	"./app/livebringgoods/logo.png": "Iqp8",
	"./app/msg.png": "RBF1",
	"./app/pay.png": "w5zi",
	"./app/poster.png": "oAV5",
	"./audio.png": "piFs",
	"./banner/img01@2x.png": "EIwb",
	"./banner/img02@2x.png": "70IY",
	"./banner/img03@2x.png": "mC9t",
	"./banner/img04@2x.png": "KR9h",
	"./binad.png": "k5wv",
	"./bindin.png": "OEbk",
	"./cloudService/icon_correct.png": "aLKj",
	"./cloudService/icon_error.png": "wUgy",
	"./color.png": "92Oy",
	"./commonIcon/assemble.png": "OSt1",
	"./commonIcon/businessCard.png": "BKIj",
	"./commonIcon/company.png": "pEIT",
	"./commonIcon/customer.png": "j28u",
	"./commonIcon/dynamic.png": "rBJ+",
	"./commonIcon/goods.png": "3q0v",
	"./commonIcon/website.png": "nLPQ",
	"./diy/banner-tongping.png": "VodW",
	"./diy/coupon.png": "NxV3",
	"./diy/goodsliststyle1.png": "46V5",
	"./diy/goodsliststyle2.png": "s4wI",
	"./diy/integral.png": "9VpQ",
	"./diy/is_sign.png": "qevb",
	"./diy/live.png": "Muhz",
	"./diy/lottery.png": "fKP4",
	"./diy/navbar_white.png": "Qf8o",
	"./diy/sign.png": "bqKU",
	"./icon/1.png": "tbYh",
	"./icon/2.png": "ihEB",
	"./icon/3.png": "twuN",
	"./icon/apps.png": "RD+4",
	"./icon_zb.png": "iGz8",
	"./logo.png": "7Otq",
	"./malls/commodity_sing01.png": "Q6xQ",
	"./malls/commodity_sing02.png": "KKgW",
	"./malls/commodity_sing03.png": "CDPJ",
	"./malls/commodity_sing04.png": "WXNM",
	"./malls/commodity_sing05.png": "r4ML",
	"./malls/commodity_sing06.png": "nkx6",
	"./nav-bg.png": "lzON",
	"./politeInvitation/invitation_icon_A.png": "AHnH",
	"./politeInvitation/invitation_icon_Q.png": "YZeI",
	"./politeInvitation/invitation_icon_tips.png": "+k8Y",
	"./sh_bg.png": "NwZI",
	"./sh_logo.png": "RkE9",
	"./shoppin/Adsense.png": "Q+1s",
	"./shoppin/Navigation.png": "oHGk",
	"./shoppin/Placeholder.png": "Ai+2",
	"./shoppin/Rotation.png": "Ijv5",
	"./shoppin/Search.png": "g6ri",
	"./shoppin/tmplate03.png": "SBK5",
	"./shoppin/tmplate04.png": "BAKA",
	"./shoppin/矢量智能对象 拷贝 8.png": "1jla",
	"./video.png": "wa1j"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32Qh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 32Qh
// module chunks = 174